var _defs, _polygon, _rect, _polygon2, _rect2, _polygon3, _rect3, _polygon4, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect5, _rect6, _polyline, _polygon5, _polyline2, _polygon6, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLawyer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 382.56 344",
    width: 406,
    height: 306,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 330.15,
    y1: 41.24,
    x2: 330.67,
    y2: 145.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 347.78,
    y1: 44.42,
    x2: 348.31,
    y2: 148.9,
    gradientTransform: "translate(429.86 -259.3) rotate(88.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 266.39,
    y1: 41.56,
    x2: 266.92,
    y2: 146.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 283.22,
    y1: 44.75,
    x2: 283.75,
    y2: 149.23,
    gradientTransform: "translate(366.99 -194.75) rotate(88.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 317.66,
    y1: 56.12,
    x2: 318.05,
    y2: 79.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 206.44,
    y1: 295.96,
    x2: 160.65,
    y2: 344.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 187.64,
    y1: 101.21,
    x2: 184.67,
    y2: 143.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 180.13,
    y1: 38.32,
    x2: 181.55,
    y2: 102.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 177.67,
    y1: 62.4,
    x2: 216.62,
    y2: 56.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 213.63,
    y1: 85.38,
    x2: 218.1,
    y2: 87.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 159.26,
    y1: 88.09,
    x2: 153.29,
    y2: 95.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 95.2,
    y1: 233.18,
    x2: 175.73,
    y2: 221.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 275.05,
    y1: 231.47,
    x2: 189.78,
    y2: 222,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 193.7,
    y1: 205.46,
    x2: 148.96,
    y2: 207.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 184.46,
    y1: 204.15,
    x2: 217.62,
    y2: 202.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 297.53,
    y1: 96.2,
    x2: 303.44,
    y2: 96.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 250.26,
    y1: 117.22,
    x2: 282.21,
    y2: 117.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 314.54,
    y1: 117.22,
    x2: 346.48,
    y2: 117.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 294.49,
    y1: 160.8,
    x2: 312.12,
    y2: 132.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 151.55,
    y1: 282.98,
    x2: 137.52,
    y2: 245.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 335.65,
    y1: 336.5,
    x2: 255.12,
    y2: 173.85,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lawyer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M106.27,318.71c-14-5.56-25-16.54-34.82-28a301.34,301.34,0,0,1-37.19-54.49C20.56,210.54,10.55,180,20.4,152.58c4-11.12,11-20.88,18.3-30.19C50,108,62.62,93.9,79,85.63c12-6.08,25.49-8.72,37.73-14.32,24.19-11.05,41.78-32.65,63.9-47.41,38.07-25.39,90.81-28.09,130-4.48,14.8,8.92,27.41,21.07,38.77,34.08,23.53,27,42.61,59,48.06,94.38,5.36,34.84-3.31,71.73-24.06,100.23S320,296.28,285,300.78c-13.5,1.74-28.39,1.74-38.82,10.5-4.4,3.7-7.56,8.65-11.52,12.82-11.64,12.28-29.43,16.88-46.35,17.12C160.45,341.62,131.8,328.86,106.27,318.71Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#008ffb",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "344.41 112.63 332.18 65.8 316.75 112.69 314.54 112.65 332.29 59.82 346.48 112.65 344.41 112.63",
    fill: "#008ffb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 323.02,
    y: 90.1,
    width: 50,
    height: 1.78,
    transform: "translate(231.52 433.32) rotate(-88.5)",
    fill: "#008ffb"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.35 112.89 267.61 65.8 252.13 112.41 250.44 111.85 267.72 59.82 283.06 112.4 281.35 112.89",
    fill: "#008ffb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 258.46,
    y: 90.1,
    width: 50,
    height: 1.78,
    transform: "matrix(0.03, -1, 1, 0.03, 168.64, 368.77)",
    fill: "#008ffb"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.41 112.63 332.18 65.8 316.75 112.69 314.54 112.65 332.29 59.82 346.48 112.65 344.41 112.63",
    fill: "url(#linear-gradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 323.02,
    y: 90.1,
    width: 50,
    height: 1.78,
    transform: "translate(231.52 433.32) rotate(-88.5)",
    fill: "url(#linear-gradient-2)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.35 112.89 267.61 65.8 252.13 112.41 250.44 111.85 267.72 59.82 283.06 112.4 281.35 112.89",
    fill: "url(#linear-gradient-3)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 258.46,
    y: 90.1,
    width: 50,
    height: 1.78,
    transform: "matrix(0.03, -1, 1, 0.03, 168.64, 368.77)",
    fill: "url(#linear-gradient-4)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.61,70.71c-3.4,0-6.22-1.43-9.14-2.91-1-.49-2-1-3-1.47-4.63-2.09-6.72,1.65-6.94,2.08A1.4,1.4,0,0,1,277,67.15c1.16-2.31,4.85-6,10.6-3.38,1.12.5,2.15,1,3.14,1.53,4.38,2.22,7.54,3.83,12.84,1.39,1.75-.8,3.12-1.48,4.32-2.07,3.67-1.82,5.51-2.73,9.51-2.73A12.44,12.44,0,0,1,324,64a13.65,13.65,0,0,0,5.81,2.14c3.38.35,11.88.77,17.6-2.9a7.15,7.15,0,0,1,5.38-.53,9.28,9.28,0,0,1,5.86,3.86,1.4,1.4,0,1,1-2.41,1.44,6.63,6.63,0,0,0-4.09-2.57,4.64,4.64,0,0,0-3.22.16c-6.24,4-14.84,3.81-19.41,3.33a16.37,16.37,0,0,1-6.91-2.49,9.87,9.87,0,0,0-5.21-1.78c-3.35,0-4.69.66-8.26,2.43-1.17.57-2.61,1.29-4.4,2.11A14.58,14.58,0,0,1,298.61,70.71Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#008ffb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.61,70.71c-3.4,0-6.22-1.43-9.14-2.91-1-.49-2-1-3-1.47-4.63-2.09-6.72,1.65-6.94,2.08A1.4,1.4,0,0,1,277,67.15c1.16-2.31,4.85-6,10.6-3.38,1.12.5,2.15,1,3.14,1.53,4.38,2.22,7.54,3.83,12.84,1.39,1.75-.8,3.12-1.48,4.32-2.07,3.67-1.82,5.51-2.73,9.51-2.73A12.44,12.44,0,0,1,324,64a13.65,13.65,0,0,0,5.81,2.14c3.38.35,11.88.77,17.6-2.9a7.15,7.15,0,0,1,5.38-.53,9.28,9.28,0,0,1,5.86,3.86,1.4,1.4,0,1,1-2.41,1.44,6.63,6.63,0,0,0-4.09-2.57,4.64,4.64,0,0,0-3.22.16c-6.24,4-14.84,3.81-19.41,3.33a16.37,16.37,0,0,1-6.91-2.49,9.87,9.87,0,0,0-5.21-1.78c-3.35,0-4.69.66-8.26,2.43-1.17.57-2.61,1.29-4.4,2.11A14.58,14.58,0,0,1,298.61,70.71Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.37,140.82a7.51,7.51,0,0,1,3.74,2,7.69,7.69,0,0,1,1.34,4c6.71,48.23,10.75,95.38-6.11,141.06A10.19,10.19,0,0,1,224,292a9.81,9.81,0,0,1-4,1.91c-15.43,4.5-31.8,4.25-47.87,3.89-7.19-.17-14.57-.38-21.25-3.06-2.26-.91-4.58-2.27-5.44-4.55a11.89,11.89,0,0,1-.39-4.42c.31-12.1-3.91-23.81-5.73-35.78-1.78-11.68-1.26-23.58-.73-35.38q.82-18.2,1.69-36.39c.44-9.24-6.12-17.45-3.75-26.52,2.12-8.12,36.24-17.78,50-17.56A157.82,157.82,0,0,1,227.37,140.82Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.36,334.05c12.66,11.53,31.22,15,48.11,12.22S221.83,335,235.8,325.11a150,150,0,0,1-9.92-35.89c.36,2.46-44.14,6.89-48.36,6.87-7.54,0-15.42-3-22.74-2.69-6.4.25-7,6.46-8,11.63Q144.05,319.53,141.36,334.05Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.36,334.05c12.66,11.53,31.22,15,48.11,12.22S221.83,335,235.8,325.11a150,150,0,0,1-9.92-35.89c.36,2.46-44.14,6.89-48.36,6.87-7.54,0-15.42-3-22.74-2.69-6.4.25-7,6.46-8,11.63Q144.05,319.53,141.36,334.05Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.56,307.9a6.34,6.34,0,0,0,2.92-1.71,5.62,5.62,0,0,0,.89-3.91,18.34,18.34,0,0,0-3.2-9.26,102.82,102.82,0,0,1-48.63,5c-5.16-.72-21.16-6.22-20,3.7.72,6.23,11.36,7,16.22,8.3A88.53,88.53,0,0,0,220.56,307.9Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174,132.36c-.87,2.09-2,4.32-1.4,6.52a7,7,0,0,0,1.27,2.42,14.2,14.2,0,0,0,24-2.19A22.49,22.49,0,0,1,195,125.85c.19-2,.59-4.31-.7-5.89a5.75,5.75,0,0,0-2.47-1.58c-4-1.58-9.7-2.1-13.34.68C175.22,121.59,175.63,128.52,174,132.36Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#f1af8c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.91,131.15a12.41,12.41,0,0,0,4.3,3.63c1.72.79,12.56,2.69,11.93.9a20.1,20.1,0,0,1-1.1-9.83c1-1.73,2.23-2.59,2.7-4.55a3.82,3.82,0,0,0,0-1.84,4.4,4.4,0,0,0-1.69-2.24,14.54,14.54,0,0,0-7.15-2.39c-2.06-.25-4.13-.38-6.2-.51a9.72,9.72,0,0,0-5,.59C171.31,118.16,177,127.52,179.91,131.15Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M172.1,121.75a21.74,21.74,0,0,0,8.66,5.55c6.1,1.89,13-.22,17.85-4.32s8-9.92,10.18-15.94c3.9-11.06,6.5-25.18,3.93-36.62-.89-4-2.23-8-4.82-11.18-9.59-11.76-34.53-8.63-45,1.25-8.83,8.3-5.35,23.75-3.49,34.22C161.13,104.61,164.82,114.55,172.1,121.75Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#f1af8c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61,85.11a3,3,0,0,0-2.7.14,3.43,3.43,0,0,0-1,2.26,8.62,8.62,0,0,0,0,4.22,8.77,8.77,0,0,0,1.6,2.58l3.16,3.94a3.72,3.72,0,0,0,1.47,1.29,3.13,3.13,0,0,0,1.61.09c1.49-.19,3.2-.95,3.39-2.44a4.06,4.06,0,0,0-.35-1.81C159.19,91.06,158.47,86.73,153.61,85.11Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#f1af8c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.69,82.32a5.92,5.92,0,0,1,5.26-4,2,2,0,0,1,1,.15,2,2,0,0,1,.85,1,11.65,11.65,0,0,1,.49,6.55A13.32,13.32,0,0,1,219.78,91a6,6,0,0,1-4,3,3.25,3.25,0,0,1-3.05-1C211.07,90.88,213,84.6,213.69,82.32Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#f1af8c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.88,82.39c-1.94-4-4.09-8.28-7.46-11.15a28.45,28.45,0,0,1,5.67-8.94c6-6.94,13.17-13,21.56-16.62s18-4.79,26.81-2.15a17.3,17.3,0,0,1,5.93,2.88,20.17,20.17,0,0,1,3.31,3.53,68.32,68.32,0,0,1,10.82,20.14,10.64,10.64,0,0,1,.78,4.64,10.66,10.66,0,0,1-1.09,3.22,79.92,79.92,0,0,1-4.79,8.82,21.48,21.48,0,0,1-.61-6.51,35.72,35.72,0,0,0-2.3-13.37,19.1,19.1,0,0,0-8.81-10,23,23,0,0,0-6.46-1.94,46.58,46.58,0,0,0-17.61.37c-6.18,1.33-12.48,4.29-15.5,9.84-2.31,4.27-2.34,9.36-2.3,14.21,0,2.25.47,11.85.47,11.85C153.33,84.41,152.08,84.49,150.88,82.39Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#c5733b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.79,81.69c-1.94-4-4-7.58-7.37-10.45a28.45,28.45,0,0,1,5.67-8.94c6-6.94,13.17-13,21.56-16.62s18-4.79,26.81-2.15a17.3,17.3,0,0,1,5.93,2.88,20.17,20.17,0,0,1,3.31,3.53,68.32,68.32,0,0,1,10.82,20.14,10.64,10.64,0,0,1,.78,4.64,10.66,10.66,0,0,1-1.09,3.22,79.92,79.92,0,0,1-4.79,8.82,21.48,21.48,0,0,1-.61-6.51,35.72,35.72,0,0,0-2.3-13.37,19.1,19.1,0,0,0-8.81-10,23,23,0,0,0-6.46-1.94,46.58,46.58,0,0,0-17.61.37c-6.18,1.33-12.48,4.29-15.5,9.84-2.31,4.27-2.34,9.36-2.3,14.21,0,2.25.47,11.85.47,11.85S152,83.79,150.79,81.69Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-8)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201,37.89c-1.85,1.87-1.86,4.88-1.29,7.44a22.09,22.09,0,0,0,4.54,9.23c1.89,2.28,4.25,4.17,5.91,6.63,2.84,4.19,3.32,9.48,4.37,14.43a4,4,0,0,0,1,2.25c1.11,1,3,.47,4-.71a8,8,0,0,0,1.25-4.28A100.92,100.92,0,0,0,220.79,57a29.68,29.68,0,0,0-2.35-10.72C216.11,41.43,206.73,32.07,201,37.89Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#c5733b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M201,37.89c-1.85,1.87-1.86,4.88-1.29,7.44a22.09,22.09,0,0,0,4.54,9.23c1.89,2.28,4.25,4.17,5.91,6.63,2.84,4.19,3.32,9.48,4.37,14.43a4,4,0,0,0,1,2.25c1.11,1,3,.47,4-.71a8,8,0,0,0,1.25-4.28A100.92,100.92,0,0,0,220.79,57a29.68,29.68,0,0,0-2.35-10.72C216.11,41.43,206.73,32.07,201,37.89Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-9)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M215.42,85.68a3.92,3.92,0,0,1,1.62-3,1.42,1.42,0,0,1,1.34-.19c.56.28.67,1,.68,1.66a10.21,10.21,0,0,1-.49,3.85c-.52,1.36-2.79,4-4.4,2.45-.88-.85.11-1.61.65-2.27A4.11,4.11,0,0,0,215.42,85.68Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-10)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.2,92.27a8.36,8.36,0,0,0-1.14-1.79,2.93,2.93,0,0,0-1.83-1c-.79-.06-1.69.49-1.67,1.28a2.13,2.13,0,0,0,.36,1,14.73,14.73,0,0,0,3.5,4.53,3,3,0,0,0,2.13.74,2.19,2.19,0,0,0,1.74-2c.07-.71-.2-2-1-2.19S156.73,93.32,156.2,92.27Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-11)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M303,185.33c-3.93,15.11-9.68,29.69-15.42,44.22-3.11,7.89-6.76,16.4-14.21,20.45a12.82,12.82,0,0,1-7.68,1.68,12.6,12.6,0,0,1-4.81-1.77c-.35-.21-.68-.43-1-.66h0a18.88,18.88,0,0,1-4-3.77,24,24,0,0,1-4.94-12.79,35.83,35.83,0,0,1,2.84-16.39c.47-1.2,1-2.39,1.58-3.55a125.91,125.91,0,0,1,8.92-14.7c.65-.95,1.29-1.91,1.93-2.87A76.8,76.8,0,0,0,273,183.08a69.59,69.59,0,0,0,3.7-12.13c1.21-5.4,1.39-5.84,5.6-2.11a99.64,99.64,0,0,0,19.25,13.38,2.2,2.2,0,0,1,1.41,3.11Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#008ffb"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M280.19,165.09c.3-.65.76-1.39,1.48-1.39a1.8,1.8,0,0,1,.89.31,40.58,40.58,0,0,1,3.85,3c3.81,2.91,8.57,4.2,13.2,5.44a5,5,0,0,1,2.55,1.26c1.23,1.4.53,3.57-.25,5.27s-1.51,3.27-2.29,4.9a3,3,0,0,1-1.45,1.69,2.92,2.92,0,0,1-1.79-.16A37.91,37.91,0,0,1,283.29,178c-1.55-1.33-4.37-3.47-5.22-5.34S279.38,166.85,280.19,165.09Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M284.51,156.39c3.58-4.38,9.72-5.82,15.36-5.51s11.09,2.08,16.66,3a48.3,48.3,0,0,0,24.65-2.29c3.25-1.23,6.36-2.85,9.68-3.92a3.58,3.58,0,0,1,3,0,2.57,2.57,0,0,1,1.05,2.1c.08,2.07-1.47,3.82-3,5.23a59.8,59.8,0,0,1-39.35,15.89,83.27,83.27,0,0,0-8.94.25c-2.69.34-5.3,1.13-8,1.62a16.2,16.2,0,0,1-8-.21C280.64,170.15,280.38,161.46,284.51,156.39Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#f1af8c"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171.24,199.37c2.93,22.25,7.14,44.47,6.89,66.91-.16,13.93-2,27.77-4.07,41.55a4.64,4.64,0,0,1-.73,2.2,4.54,4.54,0,0,1-2.77,1.31q-15.45,3.32-31.13,5.4c0-28.82.49-64.33-.75-93.11-.89-20.89-5.42-34.85-4.17-55.72l1-17.32a5.59,5.59,0,0,1,.52-2.43,5.46,5.46,0,0,1,1.84-1.73c9.44-6.38,22-13.08,33.52-14.1,1.18,3.76-1.57,10.93-2,15.1a149.28,149.28,0,0,0-.87,17.43A271.24,271.24,0,0,0,171.24,199.37Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#008ffb"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.24,199.37c2.93,22.25,7.14,44.47,6.89,66.91-.16,13.93-2,27.77-4.07,41.55a4.64,4.64,0,0,1-.73,2.2,4.54,4.54,0,0,1-2.77,1.31q-15.45,3.32-31.13,5.4c0-28.82.49-64.33-.75-93.11-.89-20.89-5.42-34.85-4.17-55.72l1-17.32a5.59,5.59,0,0,1,.52-2.43,5.46,5.46,0,0,1,1.84-1.73c9.44-6.38,22-13.08,33.52-14.1,1.18,3.76-1.57,10.93-2,15.1a149.28,149.28,0,0,0-.87,17.43A271.24,271.24,0,0,0,171.24,199.37Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-12)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M162.19,134l-11.57,71.59,11.52,12.1-7.84,19,20.53,44.21s-1.06-26.84-5.27-72.63S173.25,132,173.25,132Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#008ffb"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M201.56,133.1a4.26,4.26,0,0,0-3.13,1.36,4.47,4.47,0,0,0-.47,2.69l2.33,55.67a201.9,201.9,0,0,0,1.54,20.28c.65,4.43,1.59,8.81,2.35,13.22,4.9,28.23,2.56,57.18,4.24,85.78a3.44,3.44,0,0,0,.67,2.21,3.34,3.34,0,0,0,1.92.79,123.73,123.73,0,0,0,33,1.41q-6.78-69.12-7.48-138.66c-.11-11.37-.13-22.92-3.24-33.87a5.32,5.32,0,0,0-1-2.15,5.5,5.5,0,0,0-2.16-1.25c-5.33-2.07-10.67-4.09-16-6.21C209.58,132.54,206.47,133.1,201.56,133.1Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#008ffb"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M201.56,133.1a4.26,4.26,0,0,0-3.13,1.36,4.47,4.47,0,0,0-.47,2.69l2.33,55.67a201.9,201.9,0,0,0,1.54,20.28c.65,4.43,1.59,8.81,2.35,13.22,4.9,28.23,2.56,57.18,4.24,85.78a3.44,3.44,0,0,0,.67,2.21,3.34,3.34,0,0,0,1.92.79,123.73,123.73,0,0,0,33,1.41q-6.78-69.12-7.48-138.66c-.11-11.37-.13-22.92-3.24-33.87a5.32,5.32,0,0,0-1-2.15,5.5,5.5,0,0,0-2.16-1.25c-5.33-2.07-10.67-4.09-16-6.21C209.58,132.54,206.47,133.1,201.56,133.1Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-13)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M196.41,132.57l5.15.53,19.32,62.19-9.73,16.06,10.79,21.31-13.43,40.79s-8.66-60.37-8.54-74.66S196.41,132.57,196.41,132.57Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#008ffb"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M162.19,134l-11.57,71.59,11.52,12.1-7.84,19,20.53,44.21s-1.06-26.84-5.27-72.63S173.25,132,173.25,132Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-14)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M196.41,132.57l5.15.53,19.32,62.19-9.73,16.06,10.79,21.31-13.43,40.79s-8.66-60.37-8.54-74.66S196.41,132.57,196.41,132.57Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-15)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 297.53,
    y: 54.3,
    width: 5.9,
    height: 83.79,
    rx: 2.95,
    fill: "#008ffb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 297.53,
    y: 54.3,
    width: 5.9,
    height: 83.79,
    rx: 2.95,
    fill: "url(#linear-gradient-16)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "253.51 118.09 250.26 112.65 282.2 112.65 276.36 121.8 255.72 121.8 253.51 118.09",
    fill: "#008ffb"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.64 121.8 319.99 121.8 314.54 112.65 346.48 112.65 340.64 121.8",
    fill: "#008ffb"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "253.51 118.09 250.26 112.65 282.2 112.65 276.36 121.8 255.72 121.8 253.51 118.09",
    fill: "url(#linear-gradient-17)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.64 121.8 319.99 121.8 314.54 112.65 346.48 112.65 340.64 121.8",
    fill: "url(#linear-gradient-18)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M293.58,136.06h16.72a13.51,13.51,0,0,1,13.51,13.51v2.76a0,0,0,0,1,0,0H280.07a0,0,0,0,1,0,0v-2.76A13.51,13.51,0,0,1,293.58,136.06Z",
    fill: "#008ffb"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M293.58,136.06h16.72a13.51,13.51,0,0,1,13.51,13.51v2.76a0,0,0,0,1,0,0H280.07a0,0,0,0,1,0,0v-2.76A13.51,13.51,0,0,1,293.58,136.06Z",
    fill: "url(#linear-gradient-19)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M198.57,27.22a7,7,0,0,0-1.87-2,6.13,6.13,0,0,0-3.08-.86,20.67,20.67,0,0,0-6.72,1.18c-12.34,3.68-25,8.73-33.21,18.61-5.67,6.78-8.8,15.27-11.83,23.57-.54,1.5-1,3.37.08,4.52a4,4,0,0,0,2.68.94c5.26.34,10.42-1.24,15.45-2.82,9-2.83,18.11-5.79,26.33-10.53,7-4.08,14.93-8.94,15.8-17.57A23,23,0,0,0,198.57,27.22Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#c5733b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M268.69,219.2a41.31,41.31,0,0,1-2.73,9.58,42.1,42.1,0,0,1-2.54,5.07c-2.37,4,1.85,17.49-2.56,16.06a4.1,4.1,0,0,1-1-.66h0a53.65,53.65,0,0,1-4-3.77c-3.37-3.41-7.21-7.63-8-8.46-4.93-5.24-9.61-10.93-12.19-17.65v0c-1.21-3.13-2.06-13-2.64-24.65-.21-4.35-.39-9-.54-13.57-.61-20.2-.57-40.4-.17-39.28,1,2.65,8.54,16.17,10,18.56,3,4.74,17.89,30.23,21.91,37.65.4.72.68,1.27.84,1.62a43.33,43.33,0,0,1,3.56,9.3A28.42,28.42,0,0,1,268.69,219.2Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#008ffb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M179.26,141.11l5.45,5.06a1.05,1.05,0,0,1,.21,1.73q-4.46,6-9.46,11.5c-3-7-5.68-14.57-5.33-22.33.11-2.46.79-7.63,3.37-3.54A34,34,0,0,0,179.26,141.11Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,142a14.07,14.07,0,0,1-3.06,2.71,28.34,28.34,0,0,0-2.71,1.49,2,2,0,0,0-.58.65c-.48.93.31,2,1,2.77.8,1,7,10.45,7.21,10.22,1.48-1.86,2.17-6.47,3.12-8.65a32.69,32.69,0,0,0,2.64-8.12,12.56,12.56,0,0,0-1.35-8.29c-.31-.52-1.28-1.62-1.88-.94-.18.2-.14,1.17-.2,1.47a9,9,0,0,1-.51,1.52A19.15,19.15,0,0,1,191.92,142Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M180.33,207.54c.12,15.71.67,31.44-.48,47.1-.43,5.87-1.1,11.81,0,17.61,1.28,7.09,5,13.45,8.72,19.65,1.74-.28,2.59-2.23,3.15-3.9l7.16-21.49a10.65,10.65,0,0,0,.76-3.54,11.77,11.77,0,0,0-1-3.87c-5.27-14.27-5.05-29.88-5.94-45.07a296.39,296.39,0,0,0-5.38-41.33,32.3,32.3,0,0,1-.93-7.1,12.45,12.45,0,0,1,4.11-9.2c-2-3.24-4.29-5.18-6-7.7a17.81,17.81,0,0,0-5.1,7.56s3.89,4.11,3.24,9.44A390,390,0,0,0,180.33,207.54Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#3f3d56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M165.33,216.47c.52-3.16.39-6.4,1-9.53a21,21,0,0,1,9.79-13.88c1.46,3.69-.32,7.77-1,11.68-.22,1.25-.12,2.89,1.07,3.35,1,.38,2-.37,2.85-1.08l25.2-22c1.46,4.73-1.91,9.42-4.24,13.79a5.83,5.83,0,0,0-.8,2.27,6.81,6.81,0,0,0,.74,2.9,39.49,39.49,0,0,1,2.32,21.63c-.48,2.7-1.34,5.52-3.44,7.29a14,14,0,0,1-4.75,2.26l-23.16,7.63a3.43,3.43,0,0,1-4.83-1.44c-2.76-3.6-6.77-8.75-6.09-13.64C160.53,223.54,164.6,221,165.33,216.47Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#f1af8c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M154.75,227a10.52,10.52,0,0,0-.84,3.58c-.24,4.7,2.67,9,6,12.33a8.31,8.31,0,0,0,2.42,1.84c1.69.75,3.63.42,5.44.08.62-.12,1.34-.31,1.59-.89.37-.88-.62-1.69-1.41-2.23a14.35,14.35,0,0,1-5.38-8.14,23.59,23.59,0,0,1-.77-5.22c0-1.23.36-3.1-.5-4.14C159.13,221.63,155.63,225,154.75,227Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M165.62,214.24c.79,2.22,2.49,5.16,3.51,7.29a43.34,43.34,0,0,1,1.89,4.94,83.17,83.17,0,0,1,3.3,11.66c.16.9,1.05,4.36.84,5.26l-5,.26c-.18,0-1.13-2.51-1.3-2.59a1,1,0,0,1-.4-.48c-2.35-4.35-2.93-9.42-4.71-14a43.61,43.61,0,0,1-1.61-4.25,7.26,7.26,0,0,1,0-4.63C162.76,216.39,164.33,214.58,165.62,214.24Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M138.17,151.5a3.45,3.45,0,0,0-1.57-1.82c-.58-.24,1.46-2.32.86-2.15-5.81,1.59-11.26,10.3-12.88,16.1-3.59,13-5.61,26.28-7.62,39.57l-6.38,42.14c-.68,4.45-1.35,8.9-1.94,13.37-.33,2.53-.62,5.16.2,7.58,1.45,4.23,6.1,6.7,10.57,6.91s8.81-1.42,12.94-3.13a221.05,221.05,0,0,0,37.52-20,6,6,0,0,0,2.76-3,5.91,5.91,0,0,0-.1-2.83,100.39,100.39,0,0,0-10.91-29.06A100.57,100.57,0,0,1,138.77,230c6.22-15.81,4.86-33.45,3.41-50.38C141.4,170.54,142.32,159.62,138.17,151.5Z",
    transform: "translate(-16.44 -3.19)",
    fill: "#008ffb"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M138.17,151.5a3.45,3.45,0,0,0-1.57-1.82c-.58-.24,1.46-2.32.86-2.15-5.81,1.59-11.26,10.3-12.88,16.1-3.59,13-5.61,26.28-7.62,39.57l-6.38,42.14c-.68,4.45-1.35,8.9-1.94,13.37-.33,2.53-.62,5.16.2,7.58,1.45,4.23,6.1,6.7,10.57,6.91s8.81-1.42,12.94-3.13a221.05,221.05,0,0,0,37.52-20,6,6,0,0,0,2.76-3,5.91,5.91,0,0,0-.1-2.83,100.39,100.39,0,0,0-10.91-29.06A100.57,100.57,0,0,1,138.77,230c6.22-15.81,4.86-33.45,3.41-50.38C141.4,170.54,142.32,159.62,138.17,151.5Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-20)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M303,185.33c-3.93,15.11-9.68,29.69-15.42,44.22-3.11,7.89-6.76,16.4-14.21,20.45a12.82,12.82,0,0,1-7.68,1.68,12.6,12.6,0,0,1-4.81-1.77,4.1,4.1,0,0,1-1-.66h0a18.88,18.88,0,0,1-4-3.77c-3.37-3.41-7.21-7.63-8-8.46-4.93-5.24-9.61-10.93-12.19-17.65v0L233,194.68l-1.67-15.61,1.13,2c3.26,5.86,13,23.09,21.27,35.18,5.27,7.71,9.94,13.32,12,12.6a.91.91,0,0,0,.25-.11c6.14-3.21,21.51-46.91,21.51-46.91Z",
    transform: "translate(-16.44 -3.19)",
    fill: "url(#linear-gradient-21)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawyer);
export default __webpack_public_path__ + "static/media/lawyer.92e71f949e6fce36968071db2083001a.svg";
export { ForwardRef as ReactComponent };